import { render, staticRenderFns } from "./TestModals.vue?vue&type=template&id=5f81eeab&scoped=true&"
import script from "./TestModals.vue?vue&type=script&lang=js&"
export * from "./TestModals.vue?vue&type=script&lang=js&"
import style0 from "./TestModals.vue?vue&type=style&index=0&id=5f81eeab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81eeab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f81eeab')) {
      api.createRecord('5f81eeab', component.options)
    } else {
      api.reload('5f81eeab', component.options)
    }
    module.hot.accept("./TestModals.vue?vue&type=template&id=5f81eeab&scoped=true&", function () {
      api.rerender('5f81eeab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/TestModals.vue"
export default component.exports